import React from 'react';
import { NavLink } from 'react-router-dom';
import { FRONT_END_ADMIN } from '../../../Constants';

function Nav() {
  const onNavclick = e => {
    const menubutton = document.querySelector('.mobile-menu-button');
    const nav = document.querySelector('nav.main-nav');
    const MOBILE_MENU_OPEN_CLASS = 'open';

    if (nav.classList.contains(MOBILE_MENU_OPEN_CLASS)) {
      menubutton.classList.remove(MOBILE_MENU_OPEN_CLASS);
      nav.classList.remove(MOBILE_MENU_OPEN_CLASS);
    }
  };

  return (
    <ul id='nav'>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          How It Works
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          Buying
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          Rates
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          About
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          Advice
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? '' : '')} to='/'>
          Contact
        </NavLink>
      </li>
      <li className='main-nav__item'>
        <NavLink end onClick={onNavclick} className={({ isActive }) => (isActive ? 'active' : '')} to='/'>
          Espanol
        </NavLink>
      </li>

    </ul>
  );
}

export default Nav;
